import { httpRequest } from "../../http";
import { QuarantinedFile } from "@models/QuarantinedFile.model";

export class CommandListQuarantine {
  async run(): Promise<QuarantinedFile[]> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/quarantine/`;
    return httpRequest<QuarantinedFile[]>(url, { method: "GET" });
  }
}
